import * as React from 'react';

import './styles.css';

export class Header extends React.PureComponent {
    public render() {
        return (
            this.props.children
        );
    } 
}

export interface TopActionButtonProps {
    formatButtons?: boolean;
}

export class TopActionButtons extends React.PureComponent<TopActionButtonProps> {
    public render() {
        const formatButtons = this.props.formatButtons ?? false;

        return (
            <div className={"tn-react-scrollable-layout-action-buttons " + (formatButtons ? "format-buttons" : "")}>
                {this.props.children}
            </div>
        );
    }
}

export class ScrollableContent extends React.PureComponent {
    public render() {
        return (
            <div className="tn-react-scrollable-layout-content-wrapper">
                <div className="tn-react-scrollable-layout-content">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

interface Options {
    customClassName?: string; // defaults to nothing. this class is added to the root div if provided.
    shouldMakeTnSection?: boolean; // defaults to true. if true, then the root div is set as a tn-section
    tnSectionIsRaw?: boolean; // defaults to true. only applicable if shouldMakeTnSection is true. if true, the tn-section is a raw section.
}

export class TopActionsAndScrollableContentContainer extends React.PureComponent<Options> {
    public render() {
        return (
            <div className={"tn-react-scrollable-layout" + ((this.props.shouldMakeTnSection ?? true) ? ` tn-section ${((this.props.tnSectionIsRaw ?? true) ? "raw" : "")} ` : " ") + (this.props.customClassName ?? "")}>
                {this.props.children}
            </div>
        );
    }
}